<template lang="pug">
  .pho-number
    PhoValidationProvider(:rules="rules" :name="validationName")
      v-text-field.pho-number(
        v-model="lazyValue"
        type="number"
        :isFloat="isFloat"
        :outlined="outlined"
        :label="label"
        :dense="dense"
        :min="min"
        :max="max"
        :readonly="readonly"
        :disabled="disabled"
        @input="onInput"
      )
</template>

<script>
import { computed, watch } from 'vue';
import { useModelBinding } from '@/helpers/misc/binding';
import PhoValidationProvider from '@/components/misc/form/PhoValidationProvider.vue';
import { isNullOrEmpty } from '@/helpers/misc';

export default {
  name: 'PhoNumber',
  components: {
    PhoValidationProvider,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    isFloat: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],

  setup(props, { emit }) {
    const { lazyValue, updateValue } = useModelBinding(emit, props);

    const formatInput = value => (props.isFloat ? parseFloat(value) : parseInt(value, 10));
    const onInput = newValue => (newValue && newValue >= props.min ? emit('input', formatInput(newValue)) : emit('input', props.min));

    const validationName = computed(() => props.name || props.label);

    watch(() => lazyValue.value, () => {
      updateValue(!isNullOrEmpty(lazyValue.value) ? formatInput(lazyValue.value) : null);
    });

    return {
      lazyValue,
      onInput,
      validationName,
    };
  },
};

</script>
